import { render, staticRenderFns } from "./EventDetails.vue?vue&type=template&id=2d1e3e7c"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d1e3e7c')) {
      api.createRecord('2d1e3e7c', component.options)
    } else {
      api.reload('2d1e3e7c', component.options)
    }
    module.hot.accept("./EventDetails.vue?vue&type=template&id=2d1e3e7c", function () {
      api.rerender('2d1e3e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/EventDetails.vue"
export default component.exports